import { render } from "./Teaching.vue?vue&type=template&id=c85a2eb0"
import script from "./Teaching.vue?vue&type=script&lang=ts"
export * from "./Teaching.vue?vue&type=script&lang=ts"

import "./Teaching.vue?vue&type=style&index=0&id=c85a2eb0&rel=stylesheet&lang=scss"
script.render = render

export default script